import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Server from "../../Shared/Server"
import { FaTimes } from "react-icons/fa";
import Spinner from '../../Shared/Spinner'
import BackButton from '../../Shared/BackButton'
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const CollectorBalanceDetail = () => {
    const [transactions, setTransactions] = useState([]);
    const [title, setTitle] = useState();
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [publicID, setPublicID] = useState()
    const gridRef = useRef();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state) {
            const {payload} = location.state
            setTitle(`Collector Balance Summary From ${payload.fdate} To ${payload.tdate}`)
            fetchData({fdate: payload.fdate, tdate: payload.tdate, account_id: payload.account_id})
        }
    }, [])

    const [columnDefs] = useState([
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Date",
            field: "date",
            sortable: true,
            filter: true,
        },
        {
            headerName: "User",
            field: "username",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Opening",
            field: "opening_balance",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Debit",
            field: "debit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Credit",
            field: "credit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Balance",
            field: "balance",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Cancel",
            cellRenderer: (e) => {
                if (e.node.rowPinned) return '';
                if (!parseFloat(e.data.credit)) return '';
                return <button className="btn btn-outline-danger" onClick={()=>
                handleShow(e.data.public_id)}><FaTimes/></button>
            },
            sortable: false,
            filter: false,
        },
    ]);

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`collector-accounts/balance-detail?fdate=${payload.fdate}&tdate=${payload.tdate}&account_id=${payload.account_id}`)
            setTransactions(response?.data);
            setIsLoading(false);

            const output = response?.data.reduce((data, row) => {
                data.debit += parseFloat(row.debit);
                data.credit += parseFloat(row.credit);
                return data;
            }, {debit: 0.00, credit: 0.00, balance: 0.00});
            setPinnedBottomRowData([
                {
                    debit: parseFloat(output.debit).toFixed(2),
                    credit: parseFloat(output.credit).toFixed(2),
                    balance: (output.debit - output.credit).toFixed(2)
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data)
            }
        }
    }

    const handleClose = () => {
        setShow(false)
    }
    const handleShow = (public_id) => {
        setShow(true)
        setPublicID(public_id)
    };

    const handleDelete = async (public_id) => {
        setShow(false)
        try {
            setIsLoading(true)
            const response = await Server.delete(`/collector-accounts/cancel-collector-cash-transfer?public_id=${public_id}`)
            if (response.status === 200){
                toast.success(response.data.detail)
                setTransactions(transactions.filter((transaction) => transaction.public_id !== public_id))
                setIsLoading(false)
            }else{
                setIsLoading(false)
                toast.error(response.data.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else{
                toast.error(error.response.data?.detail)
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }


    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <BackButton
                    to="/collector-account-balance-summary"
                    state={{ fdate: location.state?.payload?.fdate, tdate: location.state?.payload?.tdate, by: location.state?.payload?.by }}
                    label="Back to Summary"
                />
            </div>
        </div>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{ title }</h3>
            </div>
            <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact

                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            
                            rowData={transactions}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                        
                            pagination={false}
                        
                            resizable={true}
                            animateRows={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Delete Alert</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure?</Modal.Body>
            <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
                No
            </Button>
            <Button variant="danger" onClick={() => handleDelete(publicID)}>
                Yes
            </Button>
            </Modal.Footer>
        </Modal>
      <br/>
    </>
  )
}

export default CollectorBalanceDetail
